import React from 'react';
import { Grid, Card, CardContent, Typography, Paper, Box } from '@mui/material';
import Icon from '@mui/material/Icon';

/* embed = true  → render without outer Paper (for inline use inside editor)  */
function ResearchTypeSelector({ types, value, onChange, embed = false }) {
  const selectedType = types.find(t => t.id === value) || types[0];

  const Content = (
    <>
      <Typography variant="body2" sx={{ mb: 2 }}>
      Each of these options will modify the survey generation process, to tailor it towards your specific needs. Click on each of the options to see a detailed explanation. 
      <br /> <br />
      For customer questions, ask questions that can be used to narrow down the target audience for your survey. For example, "What is your opinion on apples?". You can narrow down their preferences later on, by forcing specific answers or by giving them specific knowledge.
      <br /> <br />
      In case you are not sure which one to choose, you can always select "General Survey" and modify the questions later. <br />
      </Typography>


      <Grid container spacing={2}>
        {types.map(t => (
          <Grid item xs={12} sm={6} md={3} key={t.id}>
            <Card
              sx={{
                height: '100%',
                cursor: 'pointer',
                border: value === t.id ? '2px solid #4a90e2' : '1px solid #e0e0e0',
                boxShadow: value === t.id ? '0 0 10px rgba(74,144,226,0.3)' : 'none'
              }}
              onClick={() => onChange(t.id)}
            >
              <CardContent sx={{ display: 'flex', alignItems: 'center' }}>
                <Icon color="primary" sx={{ transform: 'scale(1.8)', mr: 2.5 }}>{t.icon}</Icon>
                <Typography variant="body1" fontWeight={600}>
                  {t.name}
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>

      {/* description */}
      <Box
        sx={{
          mt: 2,
          p: 2,
          backgroundColor: '#f5f5f5',
          borderRadius: 1,
          border: '1px solid #e0e0e0'
        }}
      >
        <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
          {selectedType.description}
        </Typography>
        <Typography variant="body2" color="primary" sx={{ fontStyle: 'italic' }}>
          {selectedType.example}
        </Typography>
      </Box>
    </>
  );

  return embed ? (
    Content
  ) : (
    <Paper sx={{ p: 3, mt: 2, mb: 2 }}>
      <Typography variant="h6" gutterBottom>
        Research Type
      </Typography>
      {Content}
    </Paper>
  );
}

export default ResearchTypeSelector;
